import type { NextPage } from 'next';
import Image from 'next/image';

import { SEO } from '~/components/Seo';

const Page404: NextPage = () => {
  return (
    <div className="relative flex h-screen w-screen flex-col items-center justify-between bg-slate-800 p-12">
      <SEO description="Oops, we couldn’t find that document!" />

      <div className="absolute inset-0">
        <Image
          src="https://cdn.useposeidon.com/sketch.webp"
          alt="not found background"
          fill
          className="object-cover"
          style={{ opacity: 0.4, mixBlendMode: 'multiply' }}
          unoptimized={true}
        />
      </div>
      <div className="relative z-10 flex h-full w-2/3 flex-col items-center justify-center">
        <h1 className="my-4 text-center text-5xl font-semibold leading-relaxed tracking-tight text-white">
          Looks like you hit an invalid link
        </h1>
        <p className="text-center text-lg text-white">
          If you think this is an error from a document that someone shared with you, maybe ask them to Share Again?
        </p>
      </div>
    </div>
  );
};

export default Page404;
